import polyglotI18nProvider from 'ra-i18n-polyglot';
import { de } from './i18n/de';
import { en } from './i18n/en';
import { SUPPORTED_LANGUAGES } from './i18n/languages';
import { loadTranslations } from './i18n/translationCache';

// Statische Übersetzungen (nur für de und en)
const staticTranslations: Record<string, any> = {
    de,
    en,
};

// Dynamischer Übersetzungs-Loader
function getTranslations(locale: string): any | Promise<any> {
    // Verwende statische Übersetzungen synchron wenn vorhanden (wichtig für default locale!)
    if (staticTranslations[locale]) {
        return staticTranslations[locale];
    }

    // Lade dynamisch via DeepL (nur für andere Sprachen)
    return loadTranslations(locale);
}

export const i18nProvider = polyglotI18nProvider(
    getTranslations,
    'de', // Default locale
    SUPPORTED_LANGUAGES.map(lang => ({
        locale: lang.code,
        name: `${lang.flag} ${lang.name}`,
    }))
);
